<div class="alert alert-danger" *ngIf="ServerErrors">
  <button type="button" class="close" (click)="closeServerErrors()"><span aria-hidden="true">&times;</span></button>
  <strong>Error! </strong>
  {{ ServerErrors.message }}
  <div>
    {{ ServerErrors.details }}</div>
</div>
<div class=" alert alert-danger" *ngIf="ModelStateErrors">
  <button type="button" class="close" (click)="closeModelStateErrors()"><span aria-hidden="true">&times;</span></button>
  <strong>Fix the below validations!</strong>
  <ul>
    <li *ngFor="let messageGroup of ModelStateErrors | keyvalue">
      <div *ngFor="let errorMessage of messageGroup.value">{{errorMessage}}</div>
    </li>
  </ul>
</div>

<div class=" alert alert-danger" *ngIf="alertError">
  <button type="button" class="close" (click)="closeClientErrors()"><span aria-hidden="true">&times;</span></button>
  <strong>Fix the below validations!</strong>
  <div *ngFor="let alert of alerts">
    {{ alert }}
  </div>
</div>